import { render, staticRenderFns } from "./Inicio.vue?vue&type=template&id=a6f9b002&scoped=true&"
import script from "./Inicio.vue?vue&type=script&lang=js&"
export * from "./Inicio.vue?vue&type=script&lang=js&"
import style0 from "./Inicio.vue?vue&type=style&index=0&id=a6f9b002&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6f9b002",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6f9b002')) {
      api.createRecord('a6f9b002', component.options)
    } else {
      api.reload('a6f9b002', component.options)
    }
    module.hot.accept("./Inicio.vue?vue&type=template&id=a6f9b002&scoped=true&", function () {
      api.rerender('a6f9b002', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/inicio/vistas/Inicio.vue"
export default component.exports